'use strict';

var _ = require('lodash');
var SelectedComparisonDataTransformerService = function SelectedComparisonDataTransformerService(dataUtilsService, faresOptimizerConstants) {
  function buildSelectedComparisonData(recommendationLadder) {
    var dataToBeTransformed = [];
    populateKeyForCompetitor(recommendationLadder);
    dataToBeTransformed = findApplicableData(recommendationLadder);
    return transformToSelectedComparisonData(dataToBeTransformed, recommendationLadder);
  }
  function transformToSelectedComparisonData(selectedCompetitor, recommendationLadder) {
    var entryLevelHostRbd = _.find(recommendationLadder.fareRecommendationList, {
      'fareBasisCode': recommendationLadder.hostEntryLevelFbc
    });
    var hostCarrier = entryLevelHostRbd.carrier;
    return _.transform([selectedCompetitor], function (selectedComparison, fareRecords) {
      _.forEach(fareRecords, function (fareRecord) {
        if (fareRecord !== undefined) {
          var fareChangePercent = !_.isNil(fareRecord.fareChange) && fareRecord.fareChange === 0 ? 0 : undefined;
          if (!_.isNil(fareRecord.fareChange) && fareRecord.fareChange !== 0) {
            fareChangePercent = fareRecord.fareChange / fareRecord.baseFare;
          }
          var outboundDaysOfWeek = dataUtilsService.convertDayOfWeekNumber(fareRecord.outboundDaysOfWeek);
          var fareBrandInfo = dataUtilsService.getFareBrandInfo(fareRecord.carrier, fareRecord.fareBrand);
          var isToBeSelected = isRecordWithLowestFareOrMappedComp(fareRecord, recommendationLadder);
          var result = {
            recomId: recommendationLadder.fareRecommendationRecordKey,
            _recomId: recommendationLadder._fareRecommendationRecordKey,
            carrier: fareRecord.carrier,
            rbd: fareRecord.rbd,
            compMarket: fareRecord.carrier === hostCarrier ? '' : fareRecord.origin + '-' + fareRecord.destination,
            fbc: fareRecord.fareBasisCode,
            dow: outboundDaysOfWeek,
            cardinality: fareRecord.seasonCardinality,
            minStay: fareRecord.minStay,
            maxStay: fareRecord.maxStay,
            ap: fareRecord.advancePurchase,
            currencyCode: fareRecord.currencyCode,
            nbrOfSeasons: fareRecord.outboundSeasons !== undefined ? fareRecord.outboundSeasons.length : 0,
            nbrOfBlackouts: fareRecord.outboundBlackouts !== undefined ? fareRecord.outboundBlackouts.length : 0,
            baseFare: fareRecord.baseFare,
            totalFare: fareRecord.totalFare,
            normalizedTotalFare: getNormalizedTotalFare(recommendationLadder, fareRecord),
            recomTotalFare: fareRecord.recommendedTotalFare,
            userFare: fareRecord.userTotalFare,
            effectiveFare: _.isNil(fareRecord.userTotalFare) ? fareRecord.effectiveTotalFare : fareRecord.userTotalFare,
            fareChangeAbsolute: fareRecord.fareChange,
            fareChangePercentage: fareChangePercent,
            matchPercentage: fareRecord.matchPercentage,
            yq: fareRecord.yq,
            yr: fareRecord.yr,
            q: fareRecord.q,
            airportTax: fareRecord.other,
            variable: fareRecord.variable,
            qMisc: fareRecord.qmisc,
            benchmarkFareComponent: fareRecord.benchmarkFareComponent,
            isCompetitor: fareRecord.carrier !== hostCarrier,
            isEntryLevelChanged: recommendationLadder.isEntryLevelChanged,
            tripType: faresOptimizerConstants.FARE_TYPES[fareRecord.tripType],
            fareBrand: fareBrandInfo.fareBrand,
            fareBrandName: fareBrandInfo.fareBrandName,
            selected: isToBeSelected,
            isDefaultSelection: isToBeSelected,
            travelFromDate: fareRecord.travelFromDate,
            travelToDate: fareRecord.travelToDate,
            travelCompleteDate: fareRecord.travelCompleteDate,
            firstTicketDate: fareRecord.firstTicketDate,
            lastTicketDate: fareRecord.lastTicketDate,
            effectiveDate: fareRecord.effectiveDate,
            discontinueDate: fareRecord.discontinueDate,
            outboundSeasons: fareRecord.outboundSeasons,
            outboundBlackouts: fareRecord.outboundBlackouts,
            inboundSeasons: fareRecord.inboundSeasons,
            inboundBlackouts: fareRecord.inboundBlackouts,
            reservationDates: fareRecord.reservationDates,
            ticketingDates: fareRecord.ticketingDates,
            inboundTravelDates: fareRecord.inboundTravelDates,
            outboundTravelDates: fareRecord.outboundTravelDates,
            selectedCompetitorKey: fareRecord.selectedCompetitorKey,
            competitorKey: fareRecord.competitorKey,
            fareBasisCode: fareRecord.fareBasisCode,
            previousState: isToBeSelected,
            hostRbd: fareRecord.hostRbd
          };
          dataUtilsService.assignCustomClassForSelectedCompetitor(result);
          selectedComparison.push(result);
        }
        return selectedComparison;
      }, []);
    });
  }
  function findApplicableData(recommendationLadder) {
    var applicableDataToTransform = [];
    var competitor;
    var entryLevelRbd = _.find(recommendationLadder.fareRecommendationList, {
      'fareBasisCode': recommendationLadder.hostEntryLevelFbc
    });
    var hostHighestRbd = _.find(recommendationLadder.fareRecommendationList, {
      'fareBasisCode': recommendationLadder.hostHighestFbc
    });
    var minFare = findLowestRbdFare(recommendationLadder);
    _.forEach(recommendationLadder.fareRecommendationList, function (recommendation) {
      if (_.isNil(hostHighestRbd) && !_.isNil(recommendation.useForLadderGenerationInd)) {
        applicableDataToTransform.push(recommendation);
        competitor = getBenchmarkedCompetitor(recommendationLadder, recommendation);
        applicableDataToTransform.push(competitor);
      } else if (!_.isNil(recommendation.useForLadderGenerationInd)) {
        if (recommendation.actionCode !== 'X') {
          applicableDataToTransform.push(recommendation);
          competitor = getBenchmarkedCompetitor(recommendationLadder, recommendation);
          applicableDataToTransform.push(competitor);
        }
      }
    });
    if (applicableDataToTransform.length <= 1) {
      checkAndAddHostFare(entryLevelRbd, applicableDataToTransform);
      entryLevelRbd.toBeSelected = true;
      competitor = _.find(recommendationLadder.competitorFares, {
        'isActive': true
      });
      applicableDataToTransform.push(competitor);
    }
    checkAndAddHostFare(hostHighestRbd, applicableDataToTransform);
    setIsSelectedToCompetitorMappedToLowestFareRbd(recommendationLadder, minFare);
    return applicableDataToTransform;
  }
  function checkAndAddHostFare(hostFare, applicableDataToTransform) {
    if (!applicableDataToTransform.includes(hostFare)) {
      applicableDataToTransform.push(hostFare);
    }
  }
  function populateKeyForCompetitor(recommendationLadder) {
    _.forEach(recommendationLadder.competitorFares, function (entry) {
      entry.competitorKey = [entry.carrier, entry.origin, entry.destination, entry.fareBasisCode, entry.routingNumber, entry.tariffCode, entry.footnote].filter(Boolean).join('-');
    });
  }
  function findLowestRbdFare(recommendationLadder) {
    var fares = [];
    _.forEach(recommendationLadder.fareRecommendationList, function (recommendation) {
      if (!_.isUndefined(recommendation.useForLadderGenerationInd)) {
        fares.push(recommendation.baseFare);
      }
    });
    return Math.min.apply(null, fares);
  }
  function setIsSelectedToCompetitorMappedToLowestFareRbd(recommendationLadder, minFare) {
    _.forEach(recommendationLadder.fareRecommendationList, function (recommendation) {
      if (_.isUndefined(recommendation.baseFare)) {
        var competitor = getBenchmarkedCompetitor(recommendationLadder, recommendation);
      }
      if (recommendation.baseFare === minFare) {
        competitor = getBenchmarkedCompetitor(recommendationLadder, recommendation);
      }
      if (_.isUndefined(competitor)) {
        competitor = _.find(recommendationLadder.competitorFares, {
          'isActive': true
        });
      }
      if (competitor !== undefined) {
        competitor.toBeSelected = true;
      }
    });
  }
  function getNormalizedTotalFare(recommendationLadder, fareRecord) {
    var entryLevelHostRbd = _.find(recommendationLadder.fareRecommendationList, {
      'fareBasisCode': recommendationLadder.hostEntryLevelFbc
    });
    var hostCarrier = entryLevelHostRbd.carrier;
    var normalizedTotalFare;
    if (fareRecord.carrier === hostCarrier) {
      var competitor = getBenchmarkedCompetitor(recommendationLadder, fareRecord);
      if (competitor !== undefined) {
        normalizedTotalFare = competitor.normalizedTotalFare;
      }
    } else {
      normalizedTotalFare = fareRecord.normalizedTotalFare;
    }
    return normalizedTotalFare;
  }
  function isRecordWithLowestFareOrMappedComp(fareRecord, recommendationLadder) {
    var minFare = findLowestRbdFare(recommendationLadder);
    return fareRecord.baseFare === minFare || fareRecord.toBeSelected || recommendationLadder.inventoryAssignmentMethod === faresOptimizerConstants.INVENTORY_ASSIGNMENT_METHOD.ENTRY_LEVEL_RBD && fareRecord.fareBasisCode === recommendationLadder.hostEntryLevelFbc;
  }
  function getBenchmarkedCompetitor(recommendationLadder, recommendation) {
    return _.find(recommendationLadder.competitorFares, function (compFare) {
      if (compFare.competitorKey !== undefined && compFare.competitorKey === recommendation.selectedCompetitorKey && compFare.hostRbd.includes(recommendation.rbd)) {
        return compFare;
      }
    });
  }
  return {
    buildSelectedComparisonData: buildSelectedComparisonData,
    findLowestRbdFare: findLowestRbdFare,
    setIsSelectedToCompetitorMappedToLowestFareRbd: setIsSelectedToCompetitorMappedToLowestFareRbd,
    getBenchmarkedCompetitor: getBenchmarkedCompetitor
  };
};
SelectedComparisonDataTransformerService.$inject = ['FaresOptimizerAnalysisDataUtilsService', 'FaresOptimizerConstants'];
module.exports = SelectedComparisonDataTransformerService;